var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsFile = function SvgIconsFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.444 1.333l4.186.002.055.006.028.005.045.012.07.025.068.036.048.032.02.015.048.045 4.148 4.242.058.07.016.024.027.044.03.066.024.074.006.027.008.053.004.07v6.667c0 .969-.74 1.76-1.673 1.816l-.104.003H4.444c-.946 0-1.72-.757-1.774-1.712l-.003-.107V3.152c0-.969.74-1.76 1.673-1.816l.104-.003zM8 2.545H4.444c-.303 0-.554.234-.588.536l-.004.07v9.697c0 .311.229.567.523.602l.07.005h7.11c.304 0 .555-.234.59-.536l.003-.07V6.787H8.593c-.304 0-.555-.234-.589-.536L8 6.182V2.545zm3.31 3.03L9.185 3.404v2.173h2.125z"
  })));
};
export default SvgIconsFile;